import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loanStatus, loanContracting } from 'actions/aresActions';
import FullForm from '../Layouts/FullForm';
import { recordPage } from 'utilities/uTagging';

import { formatText, HtmlText } from 'core/i18n';
const formActions = require('react-redux-form').actions;

const modalCancelActions = require('actions/modalCancelActions');
const preLoaderActions = require('actions/preLoaderActions');
const optionsActions = require('actions/optionsActions');
const TitleBox = require('components/commons/titleBox/titleBox');

const RadioButton = require('components/radioButton/radioButton');
const SelectList = require('components/selectList/selectList').SelectList;

import './Contracting.scss';
import LoanSummaryTable from '../commons/components/LoanSummaryTable/LoanSummaryTable';
import InformationSVG from '../assets/images/information-icon.svg';
import { PAYDAY_END_OF_MONTH, PAYDAY_PARTICULAR_DAY, triggerRecordEvent } from './utils';
import { RoadmapNavigation } from '../../components/steps/roadmapNavigation';

class Contracting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paydaySelected: PAYDAY_PARTICULAR_DAY,
            account: '',
        };

        this.handleOnSubmit = this.handleOnSubmit.bind(this);
    }

    componentDidMount() {
        recordPage(
            '/onboarding/prestamo-aprobado/contratacion/',
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            'ares',
            {
                tipoPagina: 'generica',
                tipoProceso: 'onboarding',
                pasoProceso: 'prestamo-aprobado',
                detalleProceso: 'contratacion',
                tipoOnboarding: 'ares',
                productoOnboardingDetalle: 'prestamo ares',
            }
        );
    }

    getLoanDataByPaymentMethod() {
        const { paydaySelected } = this.state;
        const {
            userProfile: { contractingData },
        } = this.props;

        if (!contractingData) return {};

        return contractingData.standardsData.find(payment => paydaySelected === payment.paymentDayType);
    }

    isContinueButtonDisabled() {
        const { account } = this.state;
        return !account;
    }

    handleOnSubmit() {
        const { account, paydaySelected } = this.state;
        const {
            userProfile: {
                contractingData: { paymentDay },
            },
            loanContracting,
        } = this.props;

        const bodyToSend = {
            loanAccount: account,
            paymentDayType: paydaySelected,
            paymentDay,
        };

        loanContracting(bodyToSend);
    }

    handleButtonContinueAction = () => {
        triggerRecordEvent({
            categoriaEvento: 'interaccion en prestamo aprobado contratacion',
            accionEvento: 'continuar',
        });
        this.handleOnSubmit();
    };

    handleCancelAction = () => {
        const { modalCancelActions } = this.props;
        modalCancelActions.showModalCancel();
        triggerRecordEvent({
            categoriaEvento: 'interaccion en prestamo aprobado contratacion',
            accionEvento: 'salir',
        });
    };

    render() {
        const { userProfile } = this.props;
        const { tae, totalAmount, totalCost } = this.getLoanDataByPaymentMethod();

        return (
            <React.Fragment>
                <div className="ares-contracting-form prospects-content">
                    <FullForm
                        title={formatText('stepsTitles-loanContracting_ares')}
                        icon="bills"
                        hideRoadMapNavigation={true}
                        formModel="userProfile"
                    >
                        <div className="form-container">
                            <TitleBox
                                title={formatText('loanContracting-subtitle1_ares')}
                                titleModifier="--stand-by"
                                container="--transparent"
                                dash="dash-red"
                            />
                            <LoanSummaryTable
                                tin={userProfile.tin}
                                tae={tae}
                                openingFee={userProfile.openingFee}
                                totalAmount={totalAmount}
                                monthlyFee={userProfile.monthlyFee}
                                amount={userProfile.amount}
                                frequency={userProfile.term}
                                totalCost={totalCost}
                            />
                            <div>
                                <SelectList
                                    profileModel="userProfile.loanAccount"
                                    name="account"
                                    optionsList={
                                        userProfile.accounts &&
                                        userProfile.accounts.map(account => ({
                                            label: account,
                                            value: account,
                                        }))
                                    }
                                    userProfile={userProfile}
                                    clearable={false}
                                    autoCompleteField={false}
                                    label={formatText('loanContracting-title2_ares')}
                                    placeholder={formatText('loanContracting-title2_ares')}
                                    messagesError={{ required: formatText('validation-nationalityRequired') }}
                                    required
                                    onChange={account => {
                                        this.setState({ account });
                                        triggerRecordEvent({
                                            accionEvento: 'cuenta asociada',
                                        });
                                    }}
                                    {...this.props}
                                />
                            </div>
                            <div className="blueblock">
                                <img src={InformationSVG} alt="info-icon" />
                                <p>{formatText('loanContracting-warning1_ares')}</p>
                            </div>
                            <div>
                                <div>
                                    <RadioButton
                                        label={formatText('loanContracting-title3_ares')}
                                        profileModel="userProfile.paymentDayType"
                                        optionsList={[
                                            {
                                                label: formatText('loanContracting-payoption2_ares', [
                                                    userProfile.contractingData &&
                                                        userProfile.contractingData.paymentDay,
                                                ]),
                                                value: PAYDAY_PARTICULAR_DAY,
                                            },
                                            {
                                                label: formatText('loanContracting-payoption1_ares'),
                                                value: PAYDAY_END_OF_MONTH,
                                            },
                                        ]}
                                        isRequired
                                        disabled={false}
                                        style={{ margin: '0 0 -9px', color: '#002b45' }}
                                        onChange={paydaySelected => {
                                            this.setState({ paydaySelected });
                                            triggerRecordEvent({
                                                accionEvento: 'dia de pago',
                                                etiquetaEvento: paydaySelected,
                                            });
                                        }}
                                        userProfile={userProfile}
                                        {...this.props}
                                    />
                                </div>
                            </div>
                            {this.state.paydaySelected === PAYDAY_END_OF_MONTH && (
                                <div className="blueblock">
                                    <img src={InformationSVG} alt="info-icon" />
                                    <p>{formatText('loanContracting-warning2_ares')}</p>
                                </div>
                            )}
                        </div>
                        <div className="legal-footer-container">
                            <p>{HtmlText(formatText('loanContracting-legalInfo'))}</p>
                        </div>
                    </FullForm>

                    <RoadmapNavigation
                        buttonContinueDisabled={this.isContinueButtonDisabled()}
                        buttonPrevHidden={true}
                        buttonContinueAction={this.handleButtonContinueAction}
                        cancelAction={this.handleCancelAction}
                        buttonFinalizeText={formatText('button-continue')}
                    />
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    userProfile: state.userProfile,
    userProfileForm: state.userProfileForm,
});

const mapDispatchToProps = dispatch => ({
    getLoanStatus: () => loanStatus(dispatch),
    loanContracting: payload => loanContracting(payload, dispatch),
    optionsActions: bindActionCreators(optionsActions, dispatch),
    formActions: bindActionCreators(formActions, dispatch),
    modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
    preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Contracting);
